import { ContentType, HttpClient, RequestParams } from '../http-client';

export class CompanyCrewApproval<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  // postCompanyCrewGroup = (data: any, params: RequestParams = {}) =>
  //   this.http.request<any>({
  //     path: `/api/v2/company/crew-group`,
  //     method: 'POST',
  //     body: data,
  //     secure: true,
  //     type: ContentType.Json,
  //     format: 'json',
  //     ...params,
  //   });

  getCompanyCrewApproval = (query: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/rotation/schedule`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...(query && { query }),
      ...params,
    });

  getCompanyCrewApprovalParams = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/rotation/schedule/params`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyScheduleParams = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/schedules/params`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyScheduleCrew = (query: {
    rank?: [string];
    vessel?: [number];
    crew_group?: [number];
    vessel_group?: [number];
  }, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/schedules/crew`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyScheduleByCrewId = (query: {
    cd_id?: string;
    rank?: string;
  }, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/schedules`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyScheduleCoreType = (query: {
    type?: string;
  }, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/schedules/core`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyScheduleCoreType = (data: any, query?: { cmd?: string }, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/schedules/core`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      query,
      ...params,
    });

}
